export enum MODAL_TYPES {
  LON_REDEEM_NOTICE_MODAL,
  LON_UNLOCK_COUNT_DOWN_MODAL,
  LON_FORCE_REDEEM_MODAL,
  REDEEM_LON_DEPOSIT_MODAL,
  FORCE_REDEEM_LON_DEPOSIT_MODAL,
}
